import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  requiredStar: {
    color: "red",
    marginLeft: 4,
  },
}));

